import type { AnchorHTMLAttributes, Ref } from 'react';
import { Link } from 'react-router';

export type RouterLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  ref?: Ref<HTMLAnchorElement>;
};

/**
 * Adapter that lets router-agnostic design-system (@ui) components (which pass `href`) perform
 * client-side navigation. Pass it as the `linkComponent` / `linkAs` prop.
 */
export const RouterLink = ({ href, ref, children, ...rest }: RouterLinkProps) => {
  if (/^(https?:|mailto:|tel:)/.test(href)) {
    return (
      <a ref={ref} href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  );
};
